import React, { useEffect, useImperativeHandle, useRef } from 'react';
import { observer } from 'mobx-react';

interface Props extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    minRows?: number;
}

export const AutoResizeTextarea = observer(
    React.forwardRef<HTMLTextAreaElement, Props>(({ minRows = 4, ...props }, forwardedRef) => {
        const localRef = useRef<HTMLTextAreaElement>(null);

        useImperativeHandle(forwardedRef, () => localRef.current as HTMLTextAreaElement, []);

        useEffect(() => {
            const textarea = localRef.current;
            if (!textarea) return;

            textarea.style.height = 'auto';

            const lineHeight = parseInt(getComputedStyle(textarea).lineHeight || '20', 10);
            const minHeight = lineHeight * minRows;

            textarea.style.height = `${Math.max(textarea.scrollHeight, minHeight)}px`;
        }, [props.value, minRows]);

        return (
            <textarea
                ref={localRef}
                rows={minRows}
                style={{ overflow: 'hidden', resize: 'none' }}
                {...props}
            />
        );
    }),
);
